<template>
    <div class="ui bullet">
        <div class="relative-box">
            <div class="bg-cross-animated"></div>
            <div class="pagination">
                <div
                    :key="i"
                    v-for="(slide, i) in slider.slides"
                    :class="['entry', { active: idx === i }]"
                    @click="set(i)"
                    @mouseenter="handleEnter(i)"
                    @mouseleave="handleLeave(i)"
                >
                    <span
                        class="decoration"
                    /><span class="pagination-caption">{{slide.baseline}}</span>
                </div>
                <span class="target" ref="target"/>
            </div>
            <div class="caption" >
                <span class="current-baseline">{{currentSlide.baseline}}</span>
                <span v-html="currentSlide.caption"></span>
                <Cta
                    :colors="{ hover: { background: '#114991' } }"
                    :cta="
                    currentSlide.cta"
                    class="link"
                    v-if="currentSlide.hascta"
                />
            </div>
            
        </div>
    </div>
</template>
<script>
import Cta from '@/components/FlexibleCta'
export default {
    components: {
        Cta
    },
    props: {
        slider: {
            type: Object,
            default() {}
        },
        idx: {
            type: Number,
            default: 0
        }
    },
    computed: {
        currentSlide() {
            return this.slider.slides[this.idx]
        }
    },
    methods: {
        set(idx) {
            this.$emit('set', idx)
        },
        handleEnter(i) {
            TweenMax.killTweensOf(this.$refs.target)
            TweenMax.to(this.$refs.target, .3, { y: i * 45})
        },
        handleLeave(i) {
            TweenMax.killTweensOf(this.$refs.target)
            TweenMax.to(this.$refs.target, .3, { y: this.idx * 45})
        }
    }
}
</script>
<style lang="sass" scoped>
@import "@/styles/vars.sass"

.ui
    margin-left: 5.20833%
    margin-right: 5.20833%
    padding-left: 1.25em
    padding-right: 1.25em
    user-select: none

    .bg-cross-animated
        opacity: 0
        transition: opacity .625s
    &:hover
        .bg-cross-animated
            opacity: 1
    .bullet &
        margin-top: -14.25%
        @media print
            margin-top: 0
    @include media-breakpoint-down($md)
        margin-left: 0
        margin-right: 0

    @media print
        margin-left: 9.6%
        margin-right: 9.6%
        padding-left: 0
        padding-right: 0

    .relative-box
        display: flex
        justify-content: space-between
        padding: 3.875% 5% 7.25% 5.625%
        width: 1164px
        max-width: 100%
        background-color: #ff2b2a
        @include media-breakpoint-down($md)
            flex-direction: column
        @media print
            padding: 0
            width: auto
.pagination
    position: relative
    @include media-breakpoint-down($md)
        position: absolute
.entry
    cursor: pointer
    color: #ffffff
    font-size: 17px
    font-weight: 500
    line-height: 2.6470588235
    display: flex
    align-items: center
    opacity: 0.3
    transition: opacity .3s
    white-space: nowrap
    padding-right: 3em
    @include media-breakpoint-down($md)
        margin-left: 0px
        .pagination-caption
            opacity: 0
    .decoration
        position: relative
        margin-right: 1.5em
        &:after
            content: ""
            display: block
            position: absolute
            width: 10px
            height: 10px
            top: 50%
            left: 50%
            margin-left: -5px
            margin-top: -5px
            border-radius: 50%
            background-color: #ffffff
            @include media-breakpoint-down($md)
                width: 4px
                height: 4px
                margin-left: -2px
                margin-top: -2px
    &.active
        opacity: 1
    &:hover
        .decoration
            // &:before
            //     opacity: 1

.target
    content: ""
    display: block
    width: 38px
    height: 38px
    border-radius: 50%
    border: 3px solid #ffffff
    position: absolute
    left: -19px
    top: 4px
    pointer-events: none
    @include media-breakpoint-down($md)
        left: 0
        border: 1px solid #ffffff
        width: 12px
        height: 12px
        left: -6px
        top: 16px
.current-baseline
    display: none
    font-size: 10px
    margin-bottom: 5%
    @include media-breakpoint-down($md)
        display: block
.caption
    font-size: 50px
    font-weight: 500
    color: #ffffff
    line-height: 1.2
    flex: 0.8625
    // height: 3.6em
    overflow: hidden
    display: -webkit-box
    -webkit-line-clamp: 3
    -webkit-box-orient: vertical
    flex: .85
    white-space: pre-line
    @include media-breakpoint-down($lg)
        height: 4.8em
        -webkit-line-clamp: 4
        font-size: 35px
    @include media-breakpoint-down($md)
        height: 6em
        -webkit-line-clamp: 5
        font-size: 24px
        margin-top: 4%
        margin-left: 1em

    @media print
        height: auto
        margin-left: 0
        margin-top: 0
    &::v-deep .cta 
        display: block
</style>
